import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

import {db, firebase} from '@/main'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    productos: [],
    ListaLanzamiento: [],
    ListaRemeres: [],
    ListaTazas: [],
    ventas: [],
    ListaAccesorios: [],
    usuario: {
      uid: '', 
      email: ''
    },
    error : '',
    banners: [],
    ListaBannerAll: [],
    ListaBannerPagina: [],
    ListaBannerCelular: [],
    Localidades: [],
    Provincias: [],
    anios: [],
    ListaAnios:[],
    docentes: [],
    cursos: [],
    cursosConfig: [],
    cursosAll: [],
    alumnos: [],
    listaDocentes: [],
    alumnosCurso: [],
    alumno: {},
    curso: {},
    curso2: {},
    docenteIngreso: {},
    novedades: [],
    alumnoData: {}
  },
  mutations: {
    setAnios(state, payload){
      if(payload.tipo == 'get'){
        state.anios = payload.data
      }else if(payload.tipo == 'add'){
        console.log(payload.data);
        state.anios.push(payload.data)
        console.log(payload.data);
      }else if(payload.tipo == 'delete'){
        state.anios = state.anios.filter(doc => {
          return doc.uid != payload.id
        })
      }else if(payload.tipo == 'update'){
        state.anios = state.anios.filter(doc => {
          if(doc.uid == payload.data.uid){
            doc.nombre = payload.data.nombre
            doc.activo = payload.data.activo
            doc.historico = payload.data.historico
          }
          return doc
        })
      }

      if(payload.tipo == 'add' || payload.tipo == 'update'){
        // Filtrado de Inactivos
        state.cursos = []
        state.cursosAll.forEach(c =>{
          state.anios.forEach(a => {
            if(a.uid == c.anio.uid && a.activo){
              state.cursos.push(c)
            }
          })
        })

        state.cursosConfig = []
        state.cursos.forEach(c =>{
          var cur = {
            anio: c.anio,
            docente: c.docente,
            nombre:c.nombre,
            uid: c.uid
          }
          state.cursosConfig.push(cur)
        })
      }

      state.anios = state.anios.sort(function (a, b) {
        if (parseInt(a.nombre) < parseInt(b.nombre)) { return  1; }
        if (parseInt(a.nombre) > parseInt(b.nombre)) { return -1; }
        // if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) { return -1; }
        return 0;
      });

      state.ListaAnios =[]
      state.anios.forEach(a => {
        if(a.activo){
          state.ListaAnios.push({uid: a.uid, nombre: a.nombre})
        }
      })

      // var pList = []
      // state.anios.forEach((p) =>{
      //  if(p.lanzamiento == true ){
      //    pList.push(p)
      //  }
      // });
      // state.ListaLanzamiento = pList
    },
    setNovedades(state, payload){
      if(payload.tipo == 'get'){
        state.novedades = payload.data
      }else if(payload.tipo == 'add'){
        console.log(payload.data);
        state.novedades.push(payload.data)
        console.log(payload.data);
      }else if(payload.tipo == 'delete'){
        state.novedades = state.novedades.filter(doc => {
          return doc.uid != payload.id
        })
      }

      state.novedades = state.novedades.sort(function (a, b) {
        if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
        if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
        return 0;
      });

      // var pList = []
      // state.anios.forEach((p) =>{
      //  if(p.lanzamiento == true ){
      //    pList.push(p)
      //  }
      // });
      // state.ListaLanzamiento = pList
    },
    setDocentes(state, payload){
      if(payload.tipo == 'get'){
        state.docentes = payload.data
      }else if(payload.tipo == 'add'){
        console.log(payload.data);
        state.docentes.push(payload.data)
        console.log(payload.data);
      }else if(payload.tipo == 'delete'){
        state.docentes = state.docentes.filter(doc => {
          return doc.uid != payload.id
        })
      }else if(payload.tipo == 'update'){
        state.docentes = state.docentes.filter(doc => {
          if(doc.uid == payload.data.uid){
            doc.dni = payload.data.dni,
            doc.nombre = payload.data.nombre,
            doc.clave = payload.data.clave,
            doc.activo = payload.data.activo,
            doc.full = payload.data.full
          }
          return doc
        })
      }

      state.docentes = state.docentes.sort(function (a, b) {
        if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) { return  1; }
        if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) { return -1; }
        return 0;
      });

      var pList = []
      state.docentes.forEach((p) =>{
      //  if(p.lanzamiento == true ){
         var pp = {};
         pp.uid = p.uid
         pp.nombre = p.nombre 
         pList.push(pp)
      //  }
      });
      state.listaDocentes = pList
    },
    setCursos(state, payload){
      if(payload.tipo == 'get'){
        state.cursosAll = payload.data
      }else if(payload.tipo == 'add'){
        console.log(payload.data);
        state.cursosAll.push(payload.data)
        console.log(payload.data);
      }else if(payload.tipo == 'delete'){
        state.cursosAll = state.cursosAll.filter(doc => {
          return doc.uid != payload.id
        })
      }else if(payload.tipo == 'update'){
        state.curcursosAllsos = state.cursosAll.filter(doc => {
          if(doc.uid == payload.data.uid){
            doc.nombre = payload.data.nombre,
            doc.anio = payload.data.anio,
            doc.docente = payload.data.docente
          }
          return doc
        })
      }

      state.cursosAll = state.cursosAll.sort(function (a, b) {
        if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) { return  1; }
        if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) { return -1; }
        return 0;
      });

      state.cursosAll.forEach(cur => {
        if(cur.novedades){
          cur.novedades = cur.novedades.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });
        }

      })

      // Filtrado de Inactivos
      state.cursos = []
      state.cursosAll.forEach(c =>{
        state.anios.forEach(a => {
          if(a.uid == c.anio.uid && a.activo){
            state.cursos.push(c)
          }
        })
      })

      state.cursosConfig = []
      state.cursos.forEach(c =>{
        var cur = {
          anio: c.anio,
          docente: c.docente,
          nombre:c.nombre,
          uid: c.uid
        }
        state.cursosConfig.push(cur)
      })

      // state.cursosConfig.push({
      //   anio: '',
      //   docente: 'BORRAR',
      //   nombre:'Seleccionar para Borrar',
      //   uid: 10000000
      // })
      
    },
    setAlumnos(state, payload){
      if(payload.tipo == 'get'){
        state.alumnos = payload.data
      }else if(payload.tipo == 'add'){
        console.log(payload.data);
        state.alumnos.push(payload.data)
        console.log(payload.data);
      }else if(payload.tipo == 'delete'){
        state.alumnos = state.alumnos.filter(doc => {
          return doc.uid != payload.id
        })
      }else if(payload.tipo == 'update'){
        state.alumnos = state.alumnos.filter(doc => {
          if(doc.uid == payload.data.uid){
            doc.dni = payload.data.dni,
            doc.nombre = payload.data.nombre,
            doc.curso = payload.data.curso
            doc.curso2 = payload.data.curso2,
            doc.notas = payload.data.notas ? payload.data.notas : [],
            doc.observaciones = payload.data.observaciones ? payload.data.observaciones : []
          }
          return doc
        })
      }else if(payload.tipo == 'updateCurso'){
        state.alumnos = state.alumnos.filter(doc => {
          if(doc.uid == payload.data.uid){
            doc.curso = payload.data.curso
            doc.curso2 = payload.data.curso2
            doc.notas = [],
            doc.observaciones = []
          }
          return doc
        })
      }

      state.alumnos = state.alumnos.sort(function (a, b) {
        if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) { return  1; }
        if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) { return -1; }
        return 0;
      });
      state.alumnoData = {}
    },
    setAlumnosCursos(state, payload){
      if(payload.tipo == 'get'){
        state.alumnosCurso = payload.data
      }
      
      state.alumnosCurso = state.alumnosCurso.sort(function (a, b) {
        if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) { return  1; }
        if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) { return -1; }
        return 0;
      });

      
      state.alumnosCurso.forEach(alum =>{
        if(alum.notas){
          alum.notas = alum.notas.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });
        }else{
          alum.notas = []
        }

        if(alum.observaciones){
          alum.observaciones = alum.observaciones.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });
        }else{
          alum.observaciones = [];
          console.log(alum.uid);
        }
        
      }) 
      state.alumnoData = {}
    },
    setAlumno(state, payload){
      if(payload.tipo == 'get'){
        state.alumno = payload.data[0]
      }
      if(state.alumno){
        if(state.alumno.notas){
          state.alumno.notas = state.alumno.notas.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });
        }
  
        if(state.alumno.observaciones){
          state.alumno.observaciones = state.alumno.observaciones.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });
        }
        if(state.alumno.curso == undefined){
          state.alumno = undefined;
        }
      }
    },
    setAlumnoData(state, payload){
      if(payload.tipo == 'get'){
        state.alumnoData = payload.data
      }
      if(state.alumnoData){
        if(state.alumnoData.notas){
          state.alumnoData.notas = state.alumnoData.notas.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });
        }
  
        if(state.alumnoData.observaciones){
          state.alumnoData.observaciones = state.alumnoData.observaciones.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });
        }
        // if(state.alumnoData.curso == undefined){
        //   state.alumnoData = undefined;
        // }
      }
    },
    setCurso(state, payload){
      if(payload.tipo == 'get'){
        state.curso = payload.data[0]
      }
      if(state.curso){
        if(state.curso.novedades){

          state.novedades.forEach( n => {
            state.curso.novedades.push({
              fecha: n.fecha,
              novedad: n.detalle
            })
          })

          state.curso.novedades = state.curso.novedades.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });
        }else{

          state.curso.novedades = [];
          
          state.novedades.forEach( n => {
            state.curso.novedades.push({
              fecha: n.fecha,
              novedad: n.detalle
            })
          })

          state.curso.novedades = state.curso.novedades.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });

        }
      }
    },
    setCurso2(state, payload){
      if(payload.tipo == 'get'){
        state.curso2 = payload.data[0]
      }
      if(state.curso2){
        if(state.curso2.novedades){

          state.novedades.forEach( n => {
            state.curso2.novedades.push({
              fecha: n.fecha,
              novedad: n.detalle
            })
          })

          state.curso2.novedades = state.curso2.novedades.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });
        }else{

          state.curso2.novedades = [];
          
          state.novedades.forEach( n => {
            state.curso2.novedades.push({
              fecha: n.fecha,
              novedad: n.detalle
            })
          })

          state.curso2.novedades = state.curso2.novedades.sort(function (a, b) {
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
            if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
            return 0;
          });

        }
      }
    },
    setDocente(state, payload){
      if(payload.tipo == 'get'){
        state.docenteIngreso = payload.data
      }
    },
    setAlumnoNotas(state, payload){
      var alumno1 
      var alumno2
      if(payload.tipo == 'add'){
        // alumno1 = state.alumnos.find(doc => {
        //   if(doc.uid == payload.data.alumno.uid){
        //     return doc
        //   }
        // })
        // console.log(alumno1);
        // if(alumno1.notas == undefined){
        //   alumno1.notas = []
        // }
        // alumno1.notas.push(payload.data.item)

        alumno2 = state.alumnosCurso.find(doc => {
          if(doc.uid == payload.data.alumno.uid){
            return doc
          }
        })
        if(alumno2.notas == undefined){
          alumno2.notas = []
        }
        alumno2.notas.push(payload.data.item)
        console.log(alumno2);
        
        
      }else if(payload.tipo == 'delete'){
        // alumno1 = state.alumnos.find(doc => {
        //   if(doc.uid == payload.data.alumno.uid){
        //     return doc
        //   }
        // })

        // var ubicacion = alumno1.notas.findIndex(w => w == payload.data.item)
        // alumno1.notas.splice(ubicacion, 1)

        alumno2 = state.alumnosCurso.find(doc => {
          if(doc.uid == payload.data.alumno.uid){
            return doc
          }
        })

        var ubicacion = alumno2.notas.findIndex(w => w == payload.data.item)
        alumno2.notas.splice(ubicacion, 1)
      }

      // alumno1.notas = alumno1.notas.sort(function (a, b) {
      //   if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
      //   if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
      //   return 0;
      // });

      alumno2.notas = alumno2.notas.sort(function (a, b) {
        if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
        if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
        return 0;
      });
    },
    setAlumnoObservaciones(state, payload){
      var alumno1 
      var alumno2
      // var alumno3
      if(payload.tipo == 'add'){

        if(state.alumnos.length > 0){
          alumno1 = state.alumnos.find(doc => {
            if(doc.uid == payload.data.alumno.uid){
              return doc
            }
          })
          console.log(alumno1);
          if(alumno1.observaciones == undefined){
            alumno1.observaciones = []
          }
          alumno1.observaciones.push(payload.data.item)
        }
        
        if(state.alumnosCurso.length > 0){
          alumno2 = state.alumnosCurso.find(doc => {
            if(doc.uid == payload.data.alumno.uid){
              return doc
            }
          })
          if(alumno2){
            if(alumno2.observaciones == undefined){
              alumno2.observaciones = []
            }
            alumno2.observaciones.push(payload.data.item)
            console.log(alumno2);
          }
        }

        if(state.alumnoData.uid != undefined){
          alumno2 = state.alumnoData

          if(alumno2){
            if(alumno2.observaciones == undefined){
              alumno2.observaciones = []
            }
            alumno2.observaciones.push(payload.data.item)
            console.log(alumno2);
          }
        }
      }else if(payload.tipo == 'delete'){
        if(state.alumnos.length > 0){
          alumno1 = state.alumnos.find(doc => {
            if(doc.uid == payload.data.alumno.uid){
              return doc
            }
          })
  
          var ubicacion = alumno1.observaciones.findIndex(w => w == payload.data.item)
          alumno1.observaciones.splice(ubicacion, 1)

        }

        if(state.alumnosCurso.length > 0){
          alumno2 = state.alumnosCurso.find(doc => {
            if(doc.uid == payload.data.alumno.uid){
              return doc
            }
          })
          if(alumno2){
            var ubicacion = alumno2.observaciones.findIndex(w => w == payload.data.item)
            alumno2.observaciones.splice(ubicacion, 1)
          }
        }

        if(state.alumnoData.uid != undefined){
          alumno2 = state.alumnoData

          if(alumno2){
            var ubicacion = alumno2.observaciones.findIndex(w => w == payload.data.item)
            alumno2.observaciones.splice(ubicacion, 1)
          }
        }
      }

      if(state.alumnos.length > 0){
      alumno1.observaciones = alumno1.observaciones.sort(function (a, b) {
          if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
          if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
          return 0;
        });
      }

      if(alumno2){
        alumno2.observaciones = alumno2.observaciones.sort(function (a, b) {
          if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
          if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
          return 0;
        });
      }
    },
    setCursoLibros(state, payload){
      var curso 
      if(payload.tipo == 'add'){
        curso = state.cursos.find(doc => {
          if(doc.uid == payload.data.curso.uid){
            return doc
          }
        })
        console.log(curso);
        if(curso.libros == undefined){
          curso.libros = []
        }
        curso.libros.push(payload.data.item)
        
      }else if(payload.tipo == 'delete'){
        curso = state.cursos.find(doc => {
          if(doc.uid == payload.data.curso.uid){
            return doc
          }
        })
        var ubicacion = curso.libros.findIndex(w => w == payload.data.item)
        curso.libros.splice(ubicacion, 1)
      }
    },
    setCursoNovedades(state, payload){
      var curso 
      if(payload.tipo == 'add'){
        curso = state.cursos.find(doc => {
          if(doc.uid == payload.data.curso.uid){
            return doc
          }
        })
        console.log(curso);
        if(curso.novedades == undefined){
          curso.novedades = []
        }
        curso.novedades.push(payload.data.item)
        
      }else if(payload.tipo == 'delete'){
        curso = state.cursos.find(doc => {
          if(doc.uid == payload.data.curso.uid){
            return doc
          }
        })
        var ubicacion = curso.novedades.findIndex(w => w == payload.data.item)
        curso.novedades.splice(ubicacion, 1)
      }

      curso.novedades = curso.novedades.sort(function (a, b) {
        if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) > (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return  1; }
        if ( (a.fecha.substr(6,4)+'/'+a.fecha.substr(3,2)+'/'+a.fecha.substr(0,2)) < (b.fecha.substr(6,4)+'/'+b.fecha.substr(3,2)+'/'+b.fecha.substr(0,2))) { return -1; }
        return 0;
      });
    },
  },
  actions: {
    getAnios({commit}){
      // Busco en Firebase la colleccion
      const data = []
      db.collection('anios').get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          data.push(p)
        })
        console.log(data);
        // Cargo las Varibles Globales
        commit('setAnios', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async addAnio({commit}, payload){
      payload.historico = false
      await db.collection('anios').add(
        payload
      )
      .then(doc => {
          let p = payload;
          console.log(p);
          p.uid = doc.id
        // Cargo las Varibles Globales
        console.log(p);
        commit('setAnios', {tipo:'add', data:p})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    delAnio({commit}, payload){
      db.collection('anios').doc(payload).delete()
      .then(() => {
        commit('setAnios', {tipo:'delete', id:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async putAnio({commit},payload){
      await db.collection('anios').doc(payload.uid).update({
        nombre: payload.nombre,
        activo: payload.activo,
        historico: payload.historico
      }).then(function() {
        commit('setAnios',{tipo:'update' , data:payload})
    })
    .catch(function(error) {
        console.error("Error updating document: ", error);
    });
    },
    getDocentes({commit}){
      // Busco en Firebase la colleccion
      const data = []
      db.collection('docentes').get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          data.push(p)
        })
        console.log(data);
        // Cargo las Varibles Globales
        commit('setDocentes', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async addDocente({commit}, payload){
      await db.collection('docentes').add(
        payload
      )
      .then(doc => {
          let p = payload;
          console.log(p);
          p.uid = doc.id
        // Cargo las Varibles Globales
        console.log(p);
        commit('setDocentes', {tipo:'add', data:p})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    delDocente({commit}, payload){
      db.collection('docentes').doc(payload).delete()
      .then(() => {
        commit('setDocentes', {tipo:'delete', id:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async putDocente({commit},payload){
      await db.collection('docentes').doc(payload.uid).update({
        dni: payload.dni,
        nombre: payload.nombre,
        clave: payload.clave,
        activo: payload.activo,
        full: payload.full
      }).then(function() {
        commit('setDocentes',{tipo:'update' , data:payload})
    })
    .catch(function(error) {
        console.error("Error updating document: ", error);
    });
    },
    getCursos({commit}){
      // Busco en Firebase la colleccion
      const data = []
      db.collection('cursos').get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          data.push(p)
        })
        console.log(data);
        // Cargo las Varibles Globales
        commit('setCursos', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async addCurso({commit}, payload){
      await db.collection('cursos').add(
        payload
      )
      .then(doc => {
          let p = payload;
          console.log(p);
          p.uid = doc.id
        // Cargo las Varibles Globales
        console.log(p);
        commit('setCursos', {tipo:'add', data:p})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    delCurso({commit}, payload){
      db.collection('cursos').doc(payload).delete()
      .then(() => {
        commit('setCursos', {tipo:'delete', id:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async putCurso({commit},payload){
      await db.collection('cursos').doc(payload.uid).update({
        nombre: payload.nombre,
        anio: payload.anio,
        docente: payload.docente
      }).then(function() {
        commit('setCursos',{tipo:'update' , data:payload})
    })
    .catch(function(error) {
        console.error("Error updating document: ", error);
    });
    },
    getAlumnos({commit}){
      // Busco en Firebase la colleccion
      const data = []
      db.collection('alumnos').get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          data.push(p)
        })
        console.log(data);
        // Cargo las Varibles Globales
        commit('setAlumnos', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    addLecturaAlumnos({commit, state}){
      db.collection('Lectura').doc('alumnos').set({
        data: state.alumnos
      }).then(function() {
        // commit('setAlumnos',{tipo:'get' , data:alumnos})
        console.log("Document successfully updated!");
        // modificar Set para manejar ADD, UPDATE, DELETE
    })
    .catch(function(error) {
        console.error("Error updating document: ", error);
    });
    },
    addHistorico({commit, state},payload){
      db.collection('historico').doc(payload.item.nombre).set({
        data: payload.A
      }).then(function() {
        // commit('setAlumnos',{tipo:'get' , data:alumnos})
        console.log("Document successfully updated!");
        // modificar Set para manejar ADD, UPDATE, DELETE
    })
    .catch(function(error) {
        console.error("Error updating document: ", error);
    });
    },
    async getLecturaAlumnos({commit}){
      var alumnos = []
      await db.collection('Lectura').doc('alumnos').get()
      .then(snapshot => {
        alumnos = snapshot.data().data;
        // Cargo las Varibles Globales
        commit('setAlumnos',{tipo:'get' , data:alumnos})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async addAlumno({commit, dispatch}, payload){
      await db.collection('alumnos').add(
        payload
      )
      .then(doc => {
          let p = payload;
          console.log(p);
          p.uid = doc.id
        // Cargo las Varibles Globales
        console.log(p);
        commit('setAlumnos', {tipo:'add', data:p})
        dispatch('addLecturaAlumnos')
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    delAlumno({commit, dispatch}, payload){
      db.collection('alumnos').doc(payload).delete()
      .then(() => {
        commit('setAlumnos', {tipo:'delete', id:payload})
        dispatch('addLecturaAlumnos')
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async putAlumno({commit, dispatch},payload){
      await db.collection('alumnos').doc(payload.uid).update({
        dni: payload.dni,
        nombre: payload.nombre,
        curso: payload.curso,
        curso2: payload.curso2,
        notas: payload.notas != undefined ? payload.notas : [],
        observaciones: payload.observaciones != undefined ? payload.observaciones : []
      }).then(function() {
        commit('setAlumnos',{tipo:'update' , data:payload})
        dispatch('addLecturaAlumnos')
      })
      .catch(function(error) {
          console.error("Error updating document: ", error);
      });
    },
    async putUpgradeAlumno({commit, dispatch},payload){
      var cur1 = {}
      var cur2 = {}
      if(payload.alumno.curso != undefined && payload.alumno.curso.uid != undefined){
        if(payload.alumno.curso.uid == payload.cursoActual.uid){
          cur1 = payload.curso
          payload.alumno.notas = payload.alumno.notas.filter(doc => {
            return doc.uidCurso != payload.cursoActual.uid
          })
          payload.alumno.observaciones = payload.alumno.observaciones.filter(doc => {
            return doc.uidCurso != payload.cursoActual.uid
          })
        } else {
          cur1 = payload.alumno.curso
        }
      }
      if(payload.alumno.curso2 != undefined && payload.alumno.curso2.uid != undefined ){
        if(payload.alumno.curso2.uid == payload.cursoActual.uid){
          cur2 = payload.curso
          payload.alumno.notas = payload.alumno.notas.filter(doc => {
            return doc.uidCurso != payload.cursoActual.uid
          })
          payload.alumno.observaciones = payload.alumno.observaciones.filter(doc => {
            return doc.uidCurso != payload.cursoActual.uid
          })
        } else {
          cur2 = payload.alumno.curso2
        }
      }


      await db.collection('alumnos').doc(payload.alumno.uid).update({
        curso: cur1,
        curso2: cur2,
        notas:payload.alumno.notas,
        observaciones: payload.alumno.observaciones
      }).then(function() {
        commit('setAlumnos',{tipo:'updateCurso' , data:payload})
        // dispatch('addLecturaAlumnos')
      })
      .catch(function(error) {
          console.error("Error updating document: ", error);
      });
    },
    async putEditCursoAlumno({commit, dispatch},payload){
      var cur1 = {}
      var cur2 = {}
      if(payload.alumno.curso != undefined && payload.alumno.curso.uid != undefined){
        if(payload.alumno.curso.uid == payload.curso.uid){
          cur1 = payload.curso
        } else {
          cur1 = payload.alumno.curso
        }
      }
      if(payload.alumno.curso2 != undefined && payload.alumno.curso2.uid != undefined ){
        if(payload.alumno.curso2.uid == payload.curso.uid){
          cur2 = payload.curso
        } else {
          cur2 = payload.alumno.curso2
        }
      }
      await db.collection('alumnos').doc(payload.alumno.uid).update({
        curso: cur1,
        curso2: cur2,
      }).then(function() {
        commit('setAlumnos',{tipo:'updateCurso' , data:payload})
        // dispatch('addLecturaAlumnos')
      })
      .catch(function(error) {
          console.error("Error updating document: ", error);
      });
    },
    async AlumnosCursos({commit},payload){
      const data = []
      commit('setAlumnosCursos', {tipo:'get', data:data})
      await db.collection("alumnos")
      .where("curso.uid", "==", payload).get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          p.select = false
          data.push(p)
        })
      })
      .catch((err)=>{
        console.log(err);
      });

      await db.collection("alumnos")
      .where("curso2.uid", "==", payload).get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          p.select = false
          data.push(p)
        })
      })
      .catch((err)=>{
        console.log(err);
      });

      console.log(data);
      // Cargo las Varibles Globales
      commit('setAlumnosCursos', {tipo:'get', data:data})
      
    },
    async buscarAlumno({commit},payload){
      const data = []
      await db.collection("alumnos")
      .where("dni", "==", payload).get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          data.push(p)
        })
        console.log(data);
        // Cargo las Varibles Globales
        commit('setAlumno', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async buscarAlumnoConfig({commit, state},payload){
      var data = {}
      state.alumnoData = {}
      await db.collection("alumnos")
      .where("dni", "==", payload).get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          data = p
        })
        // console.log(data);
        // return data
        // Cargo las Varibles Globales
        commit('setAlumnoData', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
        // return {}
      })
      return data
    },
    async buscarCurso({commit},payload){
      const data = []
      await db.collection("cursos")
      .doc(payload).get()
      .then(doc => {
        // console.log(snapshot);
        // snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          data.push(p)
        // })
        console.log(data);
        // Cargo las Varibles Globales
        commit('setCurso', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async buscarCurso2({commit},payload){
      const data = []
      await db.collection("cursos")
      .doc(payload).get()
      .then(doc => {
        // console.log(snapshot);
        // snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          data.push(p)
        // })
        console.log(data);
        // Cargo las Varibles Globales
        commit('setCurso2', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async ingresoDocente({commit},payload){
      const data = []
      await db.collection("docentes")
      .where("dni", "==", payload.dni)
      .where("clave", "==", payload.clave).get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          p.clave = ''
          data.push(p)
        })
        console.log(data);
        // Cargo las Varibles Globales
        commit('setDocente', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async addNota({commit},payload){
      const data = []
      payload.item.uidCurso = payload.curso.uid
      await db.collection("alumnos").doc(payload.alumno.uid).update({
        "notas": firebase.firestore.FieldValue.arrayUnion(payload.item)
       })
      .then(() => {
        commit('setAlumnoNotas', {tipo:'add', data:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async delNota({commit},payload){
      const data = []
      payload.item.uidCurso = payload.curso.uid
      await db.collection("alumnos").doc(payload.alumno.uid).update({
        "notas": firebase.firestore.FieldValue.arrayRemove(payload.item),
        // "notas": firebase.firestore.FieldValue.arrayUnion(payload.item)
       })
       .then(() => {
        commit('setAlumnoNotas', {tipo:'delete', data:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async addObservacion({commit},payload){
      const data = []
      payload.item.uidCurso = payload.curso.uid
      await db.collection("alumnos").doc(payload.alumno.uid).update({
        "observaciones": firebase.firestore.FieldValue.arrayUnion(payload.item)
       })
      .then(() => {
        commit('setAlumnoObservaciones', { tipo: 'add', data: payload })
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async delObservacion({commit},payload){
      const data = []
      payload.item.uidCurso = payload.curso.uid
      await db.collection("alumnos").doc(payload.alumno.uid).update({
        "observaciones": firebase.firestore.FieldValue.arrayRemove(payload.item)
       })
       .then(() => {
        commit('setAlumnoObservaciones', {tipo:'delete', data:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async addLibro({commit},payload){
      const data = []
      // payload.item.uidCurso = payload.alumno.curso.uid
      await db.collection("cursos").doc(payload.curso.uid).update({
        "libros": firebase.firestore.FieldValue.arrayUnion(payload.item)
       })
      .then(() => {
        commit('setCursoLibros', {tipo:'add', data:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async delLibro({commit},payload){
      const data = []
      // payload.item.uidCurso = payload.alumno.curso.uid
      await db.collection("cursos").doc(payload.curso.uid).update({
        "libros": firebase.firestore.FieldValue.arrayRemove(payload.item)
       })
       .then(() => {
        commit('setCursoLibros', {tipo:'delete', data:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async addCursoNovedad({commit},payload){
      const data = []
      // payload.item.uidCurso = payload.alumno.curso.uid
      await db.collection("cursos").doc(payload.curso.uid).update({
        "novedades": firebase.firestore.FieldValue.arrayUnion(payload.item)
       })
      .then(() => {
        commit('setCursoNovedades', {tipo:'add', data:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async delCursoNovedad({commit},payload){
      const data = []
      // payload.item.uidCurso = payload.alumno.curso.uid
      await db.collection("cursos").doc(payload.curso.uid).update({
        "novedades": firebase.firestore.FieldValue.arrayRemove(payload.item)
       })
       .then(() => {
        commit('setCursoNovedades', {tipo:'delete', data:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async cursosDocente({commit},payload){
      const data = []
      commit('setCursos', {tipo:'get', data:data})
      await db.collection("cursos")
      .where("docente.uid", "==", payload).get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          data.push(p)
        })
        console.log(data);
        // Cargo las Varibles Globales
        commit('setCursos', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    getNovedades({commit}){
      // Busco en Firebase la colleccion
      const data = []
      db.collection('novedades').get()
      .then(snapshot => {
        console.log(snapshot);
        snapshot.forEach( doc => {
          let p = doc.data();
          p.uid = doc.id
          data.push(p)
        })
        console.log(data);
        // Cargo las Varibles Globales
        commit('setNovedades', {tipo:'get', data:data})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    async addNovedad({commit}, payload){
      await db.collection('novedades').add(
        {
          fecha: payload.fecha,
          detalle: payload.detalle
        }
      )
      .then(doc => {
          let p = payload;
          // console.log(p);
          p.uid = doc.id
        // Cargo las Varibles Globales
        // console.log(p);
        commit('setNovedades', {tipo:'add', data:p})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
    delNovedad({commit}, payload){
      db.collection('novedades').doc(payload).delete()
      .then(() => {
        commit('setNovedades', {tipo:'delete', id:payload})
      })
      .catch((err)=>{
        console.log(err);
      })
    },
  }
})
